import {getAccessToken, getIdToken} from "../configurations/storages/localStorage";

export const getToken = () => {
    return {
        "id": getIdToken(),
        "access": getAccessToken(),
        "type": "Bearer"
    }
}